export function a11yProps(index) {
    return {
      id: `attributes-tab-${index}`,
      "aria-controls": `attributes-tabpanel-${index}`,
    };
  }